import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=5d760ae1&scoped=true&"
import script from "./VideoCall.vue?vue&type=script&setup=true&lang=js&"
export * from "./VideoCall.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./VideoCall.vue?vue&type=style&index=0&id=5d760ae1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d760ae1",
  null
  
)

export default component.exports